import {
  Config,
  IFinalResponse,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
  Helpers,
  Utils,
} from '../Core';
import { CommonContentRawRequest } from '../Types/internals/CommonContent.types';
import { getChannelFromBundle } from '../Utils';

export const API_DOMAIN: EndPointsNames = 'ApiOAG';
export const ENDPOINT_API_PATH = 'content/common';

export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_AUTH_USER';

export const URL_POSTMAN = ``;

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

const callGet = async (
  params: CommonContentRawRequest,
): Promise<IFinalResponse> => {
  const { UberApiKey, API_OAG_VERSION } = Helpers.getConstants();
  const init: InitApiType = {
    params,
    headers: {
      [Utils.constants.HeadersType.xApiKey]: UberApiKey,
      Channel: getChannelFromBundle(),
      API_VERSION: API_OAG_VERSION,
    },
  };

  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};

const call = { get: callGet };

export default { call, definitions };
